import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "./styles/botContentManager.css";


export default function BotContentManager() {
  const [reviewData, setReviewData] = useState({ brand: '', model: '', submodels: [{ name: '', caption: '', files: [] }] });
  const [unpackingData, setUnpackingData] = useState({ brand: '', model: '', submodels: [{ name: '', caption: '', files: [] }] });
  const [photosData, setPhotosData] = useState({ brand: '', model: '', submodels: [{ name: '', caption: '', files: [] }] });

  const [activeTab, setActiveTab] = useState('photos');
  const [entries, setEntries] = useState([]);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [editableEntry, setEditableEntry] = useState(null);


  const fetchEntries = async (type) => {
    try {
      const res = await axios.get(`https://nts-center.ru/api/get-bot-content?type=${type}`);
      console.log("🚀 ~ fetchEntries ~ res.data:", res.data)
      setEntries(res.data);
    } catch (err) {
      console.error(`Failed to fetch ${type} data`, err);
    }
  };

  useEffect(() => {
    fetchEntries(activeTab);
  }, [activeTab]);

  const handleUpload = async (type, data) => {
    const formData = new FormData();
    const brand = data.brand.trim();
    const model = data.model.trim();

    if (!brand || !model) {
      alert("❗ Please fill in all fields and add at least one submodel with file(s).\n");
      return;
    }

    formData.append("type", type);
    formData.append("brand", brand);
    formData.append("model", model);

    data.submodels.forEach((sm, index) => {
      if (!sm.name || sm.files.length === 0) return;
      formData.append(`submodels[${index}][name]`, sm.name);
      formData.append(`submodels[${index}][caption]`, sm.caption || '');
      sm.files.forEach(file => {
        formData.append(`submodels[${index}][files]`, file);
      });
    });

    try {
      const res = await axios.post('https://nts-center.ru/api/upload-bot-content', formData);
      if (res.data.success) {
        alert(`✅ ${type} uploaded successfully!`);
        fetchEntries(type);
      } else {
        throw new Error(res.data.error || "Unknown error");
      }
    } catch (err) {
      console.error(err);
      alert(`❌ Failed to upload ${type}`);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.post('https://nts-center.ru/api/delete-bot-content', { id });
      alert('✅ Deleted successfully');
      setSelectedEntry(null);
      fetchEntries(activeTab);
    } catch (err) {
      console.error('Failed to delete', err);
      alert('❌ Failed to delete');
    }
  };

  const handleAddSubmodel = (type, state, setState) => {
    const last = state.submodels[state.submodels.length - 1];
    if (!last || !last.name || last.files.length === 0) return;
    setState({
      ...state,
      submodels: [...state.submodels, { name: '', caption: '', files: [] }]
    });
  };

  const handleSubmodelChange = (type, index, field, value, setState) => {
    setState(prev => {
      const submodels = [...prev.submodels];
      submodels[index][field] = value;
      return { ...prev, submodels };
    });
  };

  const renderForm = (label, type, data, setData) => (
    <div className="bot-form">
      <h3>{label}</h3>
      <label>Brand:</label>
      <input value={data.brand} onChange={(e) => setData({ ...data, brand: e.target.value })} />
      <label>Model:</label>
      <input value={data.model} onChange={(e) => setData({ ...data, model: e.target.value })} />

      {data.submodels.map((sub, idx) => (
        <div key={idx} className="submodel-group">
          <label>Submodel:</label>
          <input
            value={sub.name}
            onChange={(e) => handleSubmodelChange(type, idx, 'name', e.target.value, setData)}
          />
          <label>Caption:</label>
          <input
            value={sub.caption}
            onChange={(e) => handleSubmodelChange(type, idx, 'caption', e.target.value, setData)}
          />
          <label>Upload File(s):</label>
          <input
            type="file"
            multiple={type === 'photos'}
            accept={type === 'photos' ? 'image/*' : 'video/*'}
            onChange={(e) => handleSubmodelChange(type, idx, 'files', Array.from(e.target.files), setData)}
          />
        </div>
      ))}

      <button type="button" onClick={() => handleAddSubmodel(type, data, setData)}>➕ Add Submodel</button>
      <button onClick={() => handleUpload(type, data)}>Upload {label}</button>
    </div>
  );

  const handleSave = async () => {
    try {
      const formData = new FormData();
      formData.append("id", editableEntry._id);
      formData.append("brand", editableEntry.brand);
      formData.append("model", editableEntry.model);
      formData.append("type", editableEntry.type || activeTab);

      editableEntry.submodels.forEach((sm, index) => {
        formData.append(`submodels[${index}][name]`, sm.name);
        formData.append(`submodels[${index}][caption]`, sm.caption || '');
        if (Array.isArray(sm.files)) {
          sm.files.forEach(file => {
            formData.append(`submodels[${index}][files]`, file);
          });
        }
      });

      const res = await axios.post('https://nts-center.ru/api/edit-bot-content', formData);
      if (res.data.success) {
        alert('✅ Обновлено успешно!');
        setSelectedEntry(null);
        setEditableEntry(null);
        fetchEntries(activeTab);
      } else {
        alert('❌ Не удалось обновить');
      }
    } catch (err) {
      console.error(err);
      alert('❌ Ошибка при сохранении');
    }
  };

  const handleEditableChange = (index, field, value) => {
    const updated = { ...editableEntry };
    updated.submodels[index][field] = value;
    setEditableEntry(updated);
  };

  const handleFileChange = (index, files) => {
    const updated = { ...editableEntry };
    updated.submodels[index].files = Array.from(files);
    setEditableEntry(updated);
  };

  const handleAddSubmodelToEdit = () => {
    const updated = { ...editableEntry };
    updated.submodels.push({ name: '', caption: '', files: [] });
    setEditableEntry(updated);
  };

  const handleRemoveSubmodelFromEdit = (index) => {
    const updated = { ...editableEntry };
    updated.submodels.splice(index, 1);
    setEditableEntry(updated);
  };


  return (
    <div className="bot-manager">
      <h2>Управление Контентом Бота</h2>
      {renderForm("🎥 Видео Обзор", "review", reviewData, setReviewData)}
      {renderForm("📦 Видео Распаковка", "unpacking", unpackingData, setUnpackingData)}
      {renderForm("📸 Фото Галерея", "photos", photosData, setPhotosData)}
      <div className="tabs">
        {['photos', 'unpacking', 'review'].map(tab => (
          <button
            key={tab}
            className={activeTab === tab ? 'active' : ''}
            onClick={() => setActiveTab(tab)}
          >
            {tab.toUpperCase()}
          </button>
        ))}
      </div>
      <div className="entry-list">
        <h4>Загруженные материалы</h4>
        {entries.map(entry => (
          <div
            key={entry._id}
            className="entry-item"
            onClick={() => {
              setSelectedEntry(entry);
              // setEditableEntry(structuredClone(entry))
              setEditableEntry({ ...structuredClone(entry), type: entry.type || activeTab });
            }}
          >
            <strong>{entry.brand}</strong> / {entry.model}
          </div>
        ))}
      </div>
      {selectedEntry && (
        <div className="custom-modal-overlay" onClick={() => {
          setSelectedEntry(null);
          setEditableEntry(null);
        }}>
          <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
            <h3>{editableEntry.brand} / {editableEntry.model}</h3>

            {/* Editable submodels */}
            {Array.isArray(editableEntry.submodels) && editableEntry.submodels.length > 0 ? (
              editableEntry.submodels.map((sm, idx) => (
                <div key={idx} className="modal-submodel">
                  <input
                    type="text"
                    value={sm.name}
                    onChange={(e) => handleEditableChange(idx, 'name', e.target.value)}
                    placeholder="Submodel name"
                  />
                  <input
                    type="text"
                    value={sm.caption}
                    onChange={(e) => handleEditableChange(idx, 'caption', e.target.value)}
                    placeholder="Caption"
                  />
                  <input
                    type="file"
                    multiple
                    accept={activeTab === 'photos' ? 'image/*' : 'video/*'}
                    onChange={(e) => handleFileChange(idx, e.target.files)}
                  />
                  <div className="media-preview">
                    {(sm.files || []).map((urlOrFile, i) => {
                      const src = typeof urlOrFile === 'string' ? urlOrFile : URL.createObjectURL(urlOrFile);
                      return src.endsWith('.mp4') ? (
                        <video key={i} src={src} controls />
                      ) : (
                        <img key={i} src={src} alt={`preview-${i}`} />
                      );
                    })}
                  </div>
                  <button onClick={() => handleRemoveSubmodelFromEdit(idx)}>🗑 Удалить</button>
                </div>
              ))
            ) : (
              <p>Нет подмоделей</p>
            )}

            <button onClick={handleAddSubmodelToEdit}>➕ Добавить подмодель</button>
            <button onClick={handleSave}>💾 Сохранить изменения</button>
            <button onClick={() => {
              setSelectedEntry(null);
              setEditableEntry(null);
            }}>Закрыть</button>
          </div>
        </div>
      )}


    </div>
  );
}
